<template>
  <div class="silk-ad-rotator" v-if="currentAdContent">
    <div v-html="currentAdContent"></div>
  </div>
</template>

<script>
import {ref, onMounted, onUnmounted} from 'vue';

let currentAd = -1;
let adsRotatorInstance = null;

export function rotateAd(){
  const adElements = document.querySelectorAll('.advertise');
  currentAd = (currentAd + 1) % adElements.length;
  if(adsRotatorInstance){
    adsRotatorInstance.displayAd(currentAd);
  }
}

export default {
  name: 'AdRotator',
  setup() {
    const currentAdContent = ref('');
    const currentAdIndex = ref(0);
    const ads = ref([]);

    const findAds = () => {
      // Find all ad elements in the document
      const adElements = document.querySelectorAll('.advertise');
      ads.value = Array.from(adElements);

    };

    const displayAd = (index) => {
      // Hide all ads in original location
      ads.value.forEach(ad => {
        ad.classList.add('d-none');
      });

      // Get and display the selected ad
      const selectedAd = ads.value[index];
      currentAdContent.value = selectedAd.innerHTML;
      currentAdIndex.value = index;
    };

    onUnmounted(() =>{
      adsRotatorInstance = null;
    });

    onMounted(() => {
      adsRotatorInstance = this;
      findAds();
      currentAdContent.value = currentAd >= 0 ? currentAd : 0;
      displayAd(currentAd);
    });

    return {
      currentAdContent
    };
  }
}
</script>
